import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/usaa_recommended.svg'
import _imports_1 from '../../assets/icons/idv/dental.svg'
import _imports_2 from '../../assets/icons/idv/vision.svg'
import _imports_3 from '../../assets/icons/idv/extend.svg'
import _imports_4 from '../../assets/tooth.svg'
import _imports_5 from '../../assets/dollar.svg'


const _withScopeId = n => (_pushScopeId("data-v-a3cfab70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "plan-header",
  "data-plan-summary-header": ""
}
const _hoisted_2 = { class: "title text-careplus" }
const _hoisted_3 = {
  "data-plan-number": "",
  class: "card-margins plan-header-title nu-mb-4 nu-mt-4"
}
const _hoisted_4 = {
  key: 0,
  "data-recommended-plan": "",
  class: "recommended-header"
}
const _hoisted_5 = { class: "nu-my-9 nu-mx-10 nu-px-4" }
const _hoisted_6 = {
  class: "m-0 nu-m-0 heading",
  "data-plan-name": ""
}
const _hoisted_7 = { class: "coverage-type regular" }
const _hoisted_8 = {
  class: "nu-font-lg",
  "data-plan-type": ""
}
const _hoisted_9 = {
  key: 1,
  class: "plan-header",
  "data-plan-card-header": ""
}
const _hoisted_10 = { class: "title text-careplus" }
const _hoisted_11 = {
  class: "text-careplus hidden-mb",
  "data-plan-type": ""
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "hidden-mb-inline"
}
const _hoisted_14 = {
  class: "text-careplus",
  "data-plan-number": ""
}
const _hoisted_15 = {
  key: 0,
  "data-recommended-plan": "",
  class: "recommended-header"
}
const _hoisted_16 = {
  key: 0,
  class: "recommended-text"
}
const _hoisted_17 = {
  key: 1,
  class: "member-recommended-text"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "member-recomm-personal-text" }, "Plan ", -1))
const _hoisted_19 = {
  key: 2,
  class: "recommended-plan-icon nu-bg-accent-primary-2"
}
const _hoisted_20 = {
  key: 1,
  "data-recommended-plan": "",
  class: "usaa-header"
}
const _hoisted_21 = {
  height: "15",
  width: "183",
  src: _imports_0,
  alt: "USAA® Recommended"
}
const _hoisted_22 = { class: "title text-careplus" }
const _hoisted_23 = {
  class: "text-careplus hidden-mb",
  "data-plan-type": ""
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "hidden-mb-inline"
}
const _hoisted_26 = {
  class: "text-careplus",
  "data-plan-number": ""
}
const _hoisted_27 = {
  key: 0,
  "data-idv-header-icon": "",
  class: "nu-bg-decorative-icon-dental",
  alt: "dental-all-plans",
  src: _imports_1
}
const _hoisted_28 = {
  key: 1,
  "data-idv-header-icon": "",
  class: "nu-bg-decorative-icon-vision",
  alt: "vision-all-plans",
  src: _imports_2
}
const _hoisted_29 = {
  key: 2,
  "data-idv-header-icon": "",
  class: "nu-bg-decorative-icon-extend",
  alt: "extend-all-plans",
  src: _imports_3
}
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "plan-name-header" }
const _hoisted_32 = {
  key: 0,
  class: "digital-first-label"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "dental-all-plans",
  src: _imports_4
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "member-exp-text" }, "Robust dental + Part B giveback", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "hoa-carryover-label"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "hoa-sign-all-plans",
  src: _imports_5
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "member-exp-text" }, "Healthy Options allowance carryover", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "coverage-type f-regular p-10"
}
const _hoisted_41 = {
  key: 1,
  class: "coverage-type f-regular"
}
const _hoisted_42 = {
  key: 2,
  class: "inline-flex"
}
const _hoisted_43 = {
  key: 3,
  class: "digital-plan-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nucleus_icon = _resolveComponent("nucleus-icon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_ctx.isPlanSummary)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["bold meta", {
    'color-bg-decorative': _ctx.consumer?.toLowerCase() == 'cp',
    'nu-bg-decorative': _ctx.consumer == 'medicare' || _ctx.consumer == 'idv',
    cp: _ctx.consumer?.toLowerCase() == 'cp',
    medicare: _ctx.consumer == 'medicare' || _ctx.consumer == 'idv',
  }])
        }, [
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.isIdv
      ? _ctx.checkIDVProductTypeCodes()
      : _ctx.plan.basicInformation.compositePlanFormNumber), 1)
          ]),
          (_ctx.isRecommended)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(" Recommended "),
                (_ctx.plan.basicInformation.isFiveStarPlan)
                  ? (_openBlock(), _createBlock(_component_nucleus_icon, {
                      key: 0,
                      name: "star-fill"
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_6, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.formatPlanName(_ctx.planNameFields)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(!_ctx.isIdv ? _ctx.coverageTypeCardFiller.text : ""), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.planTypeText), 1)
          ]),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("header", _hoisted_9, [
        (!_ctx.isIdv)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["meta-bar bold meta nu-bg-decorative", { 'cp': _ctx.consumer?.toLowerCase() == 'cp', 'medicare': (_ctx.consumer == 'medicare' || _ctx.consumer == 'idv') }])
            }, [
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.planTypeText), 1),
                (!_ctx.isFocus)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      (_ctx.isIdv ? _ctx.checkIDVProductTypeCodes() : _ctx.getPlanName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "• "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.isIdv ? _ctx.checkIDVProductTypeCodes() : _ctx.getPlanName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ((_ctx.plan.isRecommended || _ctx.isRecommended || _ctx.plan.basicInformation?.isRecommendedPlan) && !_ctx.plan.basicInformation.isHumanaHonorPlan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (!_ctx.memberexperiencemode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Recommended"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createTextVNode(" option #" + _toDisplayString(_ctx.index + 1), 1)
                        ])),
                    (_ctx.plan.isRecommended || _ctx.isRecommended || _ctx.plan.basicInformation?.isRecommendedPlan)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_nucleus_icon, {
                            name: "star-fill",
                            class: "nu-font-3xl nu-text-reversed"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.plan.basicInformation.isHumanaHonorPlan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                      [_directive_svg_inline]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["meta-bar bold meta", {'nu-bg-decorative-dental medicare': _ctx.isDental, 
    'nu-bg-decorative-vision medicare': _ctx.isVision || _ctx.isFocus, 
    'nu-bg-decorative-extend medicare': _ctx.isExtend}])
            }, [
              _createElementVNode("p", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.planTypeText), 1),
                (!_ctx.isFocus)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      (_ctx.isIdv ? _ctx.checkIDVProductTypeCodes() : _ctx.getPlanName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "• "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.isIdv ? _ctx.checkIDVProductTypeCodes() : _ctx.getPlanName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["recommended-plan-icon-idv", {'nu-bg-decorative-icon-dental': _ctx.isDental, 
          'nu-bg-decorative-icon-vision': _ctx.isVision || _ctx.isFocus, 
          'nu-bg-decorative-icon-extend': _ctx.isExtend}])
              }, [
                (_ctx.isDental)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                  : _createCommentVNode("", true),
                (_ctx.isVision || _ctx.isFocus)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                  : _createCommentVNode("", true),
                (_ctx.isExtend)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2)),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h2", {
              class: _normalizeClass(["m-0 nu-text-primary", _ctx.planHoaCarryover ? 'hoaflexwrap' : '']),
              "data-plan-name": ""
            }, _toDisplayString(_ctx.formatPlanName(_ctx.planNameFields)), 3),
            (_ctx.plan.isDigitalPlan && !_ctx.forEnrollmentOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
              : _createCommentVNode("", true),
            (_ctx.planHoaCarryover && !_ctx.forEnrollmentOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
              : _createCommentVNode("", true)
          ]),
          (_ctx.forEnrollmentOverview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createTextVNode(_toDisplayString("Coverage Type: ") + " "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.coverageTypeCardFiller.text), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(!_ctx.isIdv ? _ctx.coverageTypeCardFiller.text : ""), 1)),
          (_ctx.plan?.basicInformation?.isFiveStarPlan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (counter) => {
                  return _createVNode(_component_nucleus_icon, {
                    key: counter,
                    class: "nu-font-xl icon-sm nu-text-utility-selected-1",
                    name: "star-fill"
                  })
                }), 64)),
                _createVNode(_component_Tooltip, {
                  content: {
      tooltipHeader: 'Star rating',
      tooltipDescription: 'What is a star rating? A Medicare star rating is a plan’s overall performance and quality score that is calculated by assessing customer satisfaction, access to health care and preventive care. It is determined by government, more specifically the Center for Medicare and Medicaid services that oversees Medicare plans.'
    },
                  maxWidth: '400px'
                }, null, 8, ["content"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.plan.isDigitalPlan && !_ctx.forEnrollmentOverview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Quickly enroll online. This plan includes robust dental benefits and adds money back to your Social Security check with the Part B giveback benefit. "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.forEnrollmentOverview ? 'enrollment-additional-connect' : 'additional-content')
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 2)
      ]))
}